/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
  Button,
  DialogTitle,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Error from '@material-ui/icons/Error';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import {
  getSiteReportsBySiteId,
  changeReportDate,
} from '../../redux/actions/sites';
import ReportsSubTable from './ReportsSubTable';

const SiteAssignRow = ({ row, handleViewDetails }) => {
  const [rowOpen, setRowOpen] = useState(false);
  const [viewSizemodel, setViewSizemodel] = useState(false);
  const isProblem = row?.actionabletasks?.length > 0
    ? row?.actionabletasks.some(
      (item) => item.adminAction && item.adminComments && (item.auditorAction === '0' || item.auditorAction === null),
    )
    : false;
  const handleViewSize = () => {
    setViewSizemodel(true);
  };

  return (
    <>
      <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setRowOpen(!rowOpen)}
          >
            {rowOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell className="pl-0">
          <div className="flex flex-row items-center">
            <span>{row.siteId}</span>
            {isProblem ? (
              <Tooltip title="Review Requested" placement="top" arrow>
                <div>
                  <Error htmlColor="#f6c5d3" />
                </div>
              </Tooltip>
            ) : null}
          </div>
        </TableCell>
        <TableCell className="pl-0">
          {moment(row.newStartDate ? row.newStartDate : row.startDate).format(
            'DD MMM YYYY',
          )}
          {' '}
          to
          {' '}
          {moment(row.newEndDate ? row.newEndDate : row.endDate).format(
            'DD MMM YYYY',
          )}
        </TableCell>
        <TableCell>{row.mediaTypeName}</TableCell>
        <TableCell>{row.cityName}</TableCell>
        <TableCell>{row.locationName}</TableCell>
        <TableCell>{row.stateName}</TableCell>
        <TableCell>{row.supplierName}</TableCell>
        <TableCell>
          <Button
            className="p-0"
            basic="true"
            color="primary"
            onClick={() => {
              handleViewSize();
            }}
          >
            View Size
          </Button>
        </TableCell>
        <TableCell>{row.campaignDescription}</TableCell>
      </TableRow>
      {viewSizemodel && (
        <Dialog
          keepMounted
          disableEscapeKeyDown
          disableBackdropClick
          onClose={() => {
            setViewSizemodel(false);
          }}
          sx={{ p: 0 }}
          aria-labelledby="customized-dialog-title"
          open={viewSizemodel}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <DialogTitle
              sx={{
                m: 0,
                p: 0,
              }}
              disableTypography
            >
              <div style={{ fontWeight: 'bold' }}>Site Size Details</div>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={() => {
                setViewSizemodel(false);
              }}
              sx={(theme) => ({
                color: theme.palette.grey[500],
              })}
            >
              <ClearIcon />
            </IconButton>
          </div>
          <DialogContent dividers>
            <div
              style={{
                display: 'flex',
                marginBottom: '8px',
                alignItems: 'flex-start',
                gap: '8px',
              }}
            >
              <Typography>{`Width :-${row.width}`}</Typography>
              <Typography>{`Height :-${row.height}`}</Typography>
            </div>
            <div
              className="flex flex-row items-start mb-2 gap-2"
              style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}
            >
              <Typography>{`Site Area :-${row.siteArea}`}</Typography>
              <Typography>{`Media Type :-${row.illumination}`}</Typography>
            </div>
          </DialogContent>
        </Dialog>
      )}
      <ReportsSubTable
        open={rowOpen}
        site={row}
        vendorUser={[]}
        handleViewDetails={handleViewDetails}
        handleWatermark={() => null}
        setDatePicker={() => null}
        addNewTask={() => null}
      />
    </>
  );
};

const mapActions = {
  getSiteReports: getSiteReportsBySiteId,
  changeDate: changeReportDate,
};

export default connect(null, mapActions)(SiteAssignRow);
